module.exports = __webpack_public_path__ + "static/media/consdata.4006f29c.png";